import { Button, Dialog, IconButton, Text, Tooltip, Flex } from '@radix-ui/themes';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ResendInvitationEmail = ({
  user,
  loading,
  onSubmit,
}: {
  user: { email: string; firstName: string; lastName: string };
  loading: boolean;
  onSubmit: (user: { email: string; firstName: string; lastName: string }) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(user).then(() => {});
  };

  return (
    <Dialog.Root>
      <Tooltip content={<Text size="3">{t('settings.accessGroupDialogs.resendInvitationEmail.tooltip')}</Text>}>
        <Dialog.Trigger>
          <IconButton variant="ghost" color="gray" highContrast className="m-0">
            <Send size={20} />
          </IconButton>
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content style={{ maxWidth: 450 }}>
        <Dialog.Title>{t('settings.accessGroupDialogs.resendInvitationEmail.dialogTitle')}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          {t('settings.accessGroupDialogs.resendInvitationEmail.description', {
            userName: `${user.firstName} ${user.lastName}`,
          })}
        </Dialog.Description>

        <Flex gap="3" mt="4" justify="between">
          <Dialog.Close>
            <Button size="3" color="gray" variant="soft">
              {t('settings.accessGroupDialogs.resendInvitationEmail.cancelButton')}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button size="3" color="amber" loading={loading} onClick={handleSubmit}>
              {t('settings.accessGroupDialogs.resendInvitationEmail.sendButton')}
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default ResendInvitationEmail;
